<template>
  <div>
    <entry-status />
    <info-from-company />
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import EntryStatus from '@/components/Home/EntryStatus'
import InfoFromCompany from '@/components/Home/InfoFromCompany'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    EntryStatus,
    InfoFromCompany
  }
}
</script>
